import { useAuth } from '../../hooks/useAuth'
import React from 'react'
import TextareaAutosize from 'react-textarea-autosize'

interface Props {
	className?: string
	multiLine?: boolean
	[key: string]: any
	keyPath?: (string | number)[]
	onChangePrio?: Function
	onBlurPrio?: Function
	valuePrio?: any
	isInt?: Boolean
	isFloat?: Boolean
	formState?: any
	setFormState?: Function
	name?: string
	teamId?: string
	type?: string
}
const Input = ({
	className,
	multiLine = false,
	keyPath,
	onChangePrio,
	onBlurPrio,
	valuePrio,
	isInt,
	isFloat,
	formState,
	setFormState,
	name,
	teamId,
	type = 'text',
	...rest
}: Props) => {
	const auth = useAuth()
	const initValue: any = auth.userDTO?.teams
	const valueFromKeyPath = keyPath?.reduce((acc, key) => acc?.[key], initValue)
	const oid: string | undefined =
		teamId ??
		(keyPath && keyPath.length > 0 ? (keyPath[0] as string) : undefined)
	const o = useAuth().userDTO?.teams?.[oid ?? '']
	let value: any = ''
	if (valuePrio) {
		value = valuePrio
	} else if (formState && name) {
		value = formState?.[name] ?? ''
	} else if (keyPath) {
		value = valueFromKeyPath ?? ''
	}

	const onChange = (value: string) => {
		let i = parseInt(value)
		let f = parseFloat(value)
		if (onChangePrio) {
			onChangePrio(value)
		} else if (keyPath) {
			if (isInt && !isNaN(i)) {
				auth.updateClient({
					keyPath: keyPath,
					value: i,
					operation: 'setValue',
				})
			} else if (isInt && value == '') {
				auth.updateClientAndServer({
					keyPath: keyPath,
					operation: 'removeKey',
				})
			} else if (isFloat && !isNaN(f)) {
				auth.updateClient({
					keyPath: keyPath,
					value: f,
					operation: 'setValue',
				})
			} else if (isFloat && value == '') {
				auth.updateClientAndServer({
					keyPath: keyPath,
					operation: 'removeKey',
				})
			} else if (!isInt && !isFloat) {
				auth.updateClient({
					keyPath: keyPath,
					value: value,
					operation: 'setValue',
				})
			}
		} else if (formState && setFormState && name) {
			if (isInt && !isNaN(i)) {
				setFormState({
					...formState,
					[name]: i,
				})
			} else if (isFloat && !isNaN(f)) {
				setFormState({
					...formState,
					[name]: f,
				})
			} else if (!isInt && !isFloat) {
				setFormState({
					...formState,
					[name]: value,
				})
			}
		}
	}

	const onBlur = (value: string) => {
		if (onBlurPrio) {
			onBlurPrio(value)
		} else if (keyPath) {
			let i = parseInt(value)
			let f = parseFloat(value)
			if (isInt && !isNaN(i)) {
				auth.updateClientAndServer({
					keyPath: keyPath,
					value: value == '' ? '' : i,
					operation: 'setValue',
				})
			} else if (isInt && value == '') {
				auth.updateClientAndServer({
					keyPath: keyPath,
					operation: 'removeKey',
				})
			} else if (isFloat && !isNaN(i)) {
				auth.updateClientAndServer({
					keyPath: keyPath,
					value: f,
					operation: 'setValue',
				})
			} else if (isFloat && value == '') {
				auth.updateClientAndServer({
					keyPath: keyPath,
					operation: 'removeKey',
				})
			} else if (!isInt && !isFloat) {
				auth.updateClientAndServer({
					keyPath: keyPath,
					value: value,
					operation: 'setValue',
				})
			}
		}
	}

	return multiLine ? (
		<TextareaAutosize
			className={className ?? 'input-text'}
			{...rest}
			value={value}
			onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
				onChange(e.target.value)
			}}
			onBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
				onBlur(e.target.value)
			}}
			minRows={5}
			maxRows={5}
			disabled={o?.scope?.range != 'all' && !auth?.userDTO?.isTikexAdmin}
			style={{ maxWidth: 'unset' }}
		/>
	) : (
		<input
			className={className ?? 'input-text'}
			value={value}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
				onChange(e.target.value)
			}}
			onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
				onBlur(e.target.value)
			}}
			disabled={o?.scope?.range != 'all' && !auth?.userDTO?.isTikexAdmin}
			type={type}
			{...rest}
		/>
	)
}

export default Input
